import { Injectable, EventEmitter } from '@angular/core';
import { Headers, RequestOptions, URLSearchParams } from '@angular/http';
import { GLOBAL } from '../shared/global';
import { Observable } from 'rxjs/Observable';
import { ApiService } from './api.service';
import { Subject } from 'rxjs/Subject';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/distinctUntilChanged';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/switchMap';
import 'rxjs/add/operator/toPromise';
import 'rxjs/add/observable/throw';
import 'rxjs/add/observable/interval';
import { of } from 'rxjs/observable/of';

    @Injectable()
export class MessagingService extends ApiService {
    messageThreadCount = new EventEmitter<string>();
    isValidHttp(): boolean {
            return (this.http !== undefined || this.http !== null);
        }

        getInterpreterMessages(user_id, page): Observable < any > {
            let headers = new Headers({ 'Accept': 'application/json' });
            let options = new RequestOptions({ headers: headers, params: {sub_org: 'ALL'} });

            return this.http.get(GLOBAL.USER_API + '/' + user_id + '/messages' + '?page=' + 1 + '&amp;per_page=' + page * 10, options)
                    .map(this.extractData)
                    .catch((err) => { return this.handleError(err); });
        }

        getInterpreterMessage(message_thread_id, business_id, page): Observable<any> {
            let headers = new Headers({ 'Accept': 'application/json' });
            let options = new RequestOptions({ headers: headers, params: {sub_org: 'ALL'} });

            return this.http.get(GLOBAL.USER_APPI + '/business/' + business_id + '/message_threads/' + message_thread_id
                                                    + '?page=' + 1 + '&amp;per_page=' + page * 10, options)
                .map(this.extractData)
                .catch((err) => { return this.handleError(err); });
        }

        sendInterpreterMessages(user_id, url, inbox_url_id, message_body): Observable < Object > {
        let headers = new Headers({ 'Accept': 'application/json' });
        let options = new RequestOptions({ headers: headers, params: {sub_org: 'ALL'} });
        const obj = { message: { message_inbox_url: url, message_body: message_body } };

             return this.http.post(GLOBAL.USER_API + '/' + user_id + '/messages', JSON.stringify(obj), options)
                    .map(this.extractData)
                    .catch((err) => { return this.handleError(err); });
        }

        sendMessages(logged_in_user_id, inbox_url_id, message_body, receiver_id, message_tag): Observable<Object> {
            let headers = new Headers({'Accept': 'application/json'});
            let options = new RequestOptions({headers: headers, params: {sub_org: 'ALL'}});
            let obj = Boolean(receiver_id) ? {
                    message: {
                        receiver_id: receiver_id, message_inbox_url: inbox_url_id, message_body: message_body
                        , tag: message_tag
                    }
                }
                : {message: {message_inbox_url: inbox_url_id, message_body: message_body, tag: message_tag}};

            return this.http.post(GLOBAL.USER_API + '/' + logged_in_user_id + '/messages', JSON.stringify(obj), options)
                .map(this.extractData)
                .catch((err) => {
                    return this.handleError(err);
                });
        }

        allMessageThreads(businessId, page, interpreter_search, params = {}): Observable<any> {
            let headers = new Headers({ 'Accept': 'application/json' });
            let options = new RequestOptions({ headers: headers, params: {sub_org: 'ALL', ...params} });

            return this.http.get(GLOBAL.USER_APPI + '/business/' + businessId + '/message_threads'
                + '?interpreter_name=' + interpreter_search + '&page=' + page + '&amp;per_page=' + 10, options)
                .map(this.extractData)
                .catch((err) => { return this.handleError(err); });
        }

        pollingAllMessageThreads(businessId, page, interpreter_search): Observable<any> {
            let headers = new Headers({ 'Accept': 'application/json' });
            let options = new RequestOptions({ headers: headers, params: {sub_org: 'ALL'} });

            return Observable.interval(60 * 1000).switchMap(() =>
                this.http.get(GLOBAL.USER_APPI + '/business/' + businessId + '/message_threads'
                + '?interpreter_name=' + interpreter_search + '&page=' + page + '&amp;per_page=' + 10, options)
                .map(this.extractData)
                // don't throw error, it will break interval stream
                .catch((err) => { return of(err); }));
        }

        threadMarkAsRead(businessId: number, messageThreadId: number): Observable < Object > {
            let headers = new Headers({ 'Accept': 'application/json' });
            let options = new RequestOptions({ headers: headers, params: {sub_org: 'ALL'} });

            return this.http.post(GLOBAL.USER_APPI + '/business/' + businessId + '/message_threads/' + messageThreadId + '/mark_as_read', options)
                .map(this.extractData)
                .catch((err) => { return this.handleError(err); });
        }
}




// WEBPACK FOOTER //
// ./src/app/api/messaging.service.ts